import { toast } from "sonner";

import usePageTitle from "hooks/usePageTitle";
import ContactEmailForm from "routes/contact/ContactEmailForm";
import RecordIdCard from "routes/ui_sandbox/RecordIdCard";
import useRecordIdParam from "routes/ui_sandbox/useRecordIdParam";

const ContactEmailFormPage = () => {
  usePageTitle("Contact Email Form");
  const { id, setId, clearId } = useRecordIdParam();

  return (
    <>
      <RecordIdCard
        label="Contact ID"
        description="Load the contact to send the email to."
        id={id}
        onLoad={setId}
        onClear={clearId}
      />
      {id != null && (
        <ContactEmailForm
          key={id}
          contactId={id}
          onSuccess={() => toast.success("Email sent")}
          onCancel={clearId}
        />
      )}
    </>
  );
};

export default ContactEmailFormPage;
